import { render, staticRenderFns } from "./PresupuestoProyectadoIngresos.vue?vue&type=template&id=20fe1019&scoped=true"
import script from "./PresupuestoProyectadoIngresos.vue?vue&type=script&lang=js"
export * from "./PresupuestoProyectadoIngresos.vue?vue&type=script&lang=js"
import style0 from "./PresupuestoProyectadoIngresos.vue?vue&type=style&index=0&id=20fe1019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe1019",
  null
  
)

export default component.exports